







































import Vue from 'vue'
import mixins from 'vue-typed-mixins'
import { isDesktopMixin } from '@/mixins'
import VueI18n from 'vue-i18n'
import easyapi from '@/easyapi'
import { reqMan } from '@/singleton'

type category_t = 'ui' | 'basicinfo' | 'network' | 'maintenance'

export default mixins(isDesktopMixin).extend({
  components: {
  },
  computed: {
    mini (): boolean {
      return this.$vuetify.breakpoint.name === 'xs'
    },
    showLeftSideBar (): boolean {
      const breakpoint = this.$vuetify.breakpoint.name
      return (breakpoint !== 'xs' || (breakpoint === 'xs' && this.$route.name === 'sys'))
    },
    activeCategory (): category_t {
      const routerName = this.$route.name
      if (!routerName) { return 'ui' }
      if (routerName.startsWith('sys_ui')) { return 'ui' }
      if (routerName.startsWith('sys_basicinfo')) { return 'basicinfo' }
      if (routerName.startsWith('sys_network')) { return 'network' }
      if (routerName.startsWith('sys_maintenance')) { return 'maintenance' }
      return 'ui'
    }
  },
  methods: {
    clickLeftIcon () { this.$router.go(-1) },
  },
  mounted () {
    reqMan.ensureWsAvailable(() => {
      easyapi.fetchSystemBasicInfo()
    })
  }
})
